const muster = require('@dbk-legacy/muster');
const flow = require('lodash/fp/flow');
const assert = require('assert');

const addInvestmentRoutes = require('./investments');
const addPortfolioRoutes = require('./portfolios');
const addAuthRoutes = require('./auth');
const addAlternativesRoutes = require('./alternatives');
const addBondsRoutes = require('./bonds');
const addEquitiesRoutes = require('./equities');
const addMMInstruments = require('./mm-instruments');
const addVariousRoutes = require('./various');
const addCashRoutes = require('./cash');
const addLoansRoutes = require('./loans');
const addOptionsRoutes = require('./options');
const addFxForwardsRoutes = require('./fx-forwards');
const addEntitlementRoutes = require('./entitlement');
const addMaturitiesRoutes = require('./maturities');
const addIncomeRoutes = require('./income');
const addConsolidationeRoutes = require('./consolidation-setup');
const addCurrencyRoutes = require('./currencies');
const addReportsRoutes = require('./reports');
const addReportAdvicesRoutes = require('./report-advices');
const addCioInsightsRoutes = require('./cioinsights');
const addNotifications = require('./notifications');
const addRmCallback = require('./rmcallback');
const addPortfolioAssetsRoutes = require('./portfolioassetlist');
const addDiscovery = require('./discovery');
const marqueRoutes = require('./marque');
const addFeedback = require('./feedback');
const addVascoAuthentication = require('./vascoauthentication');
const addTermsAndConditions = require('./terms-conditions');
const addGlobalAuth = require('./globalauth');
const addGenericAssetsRoutes = require('./genericAssets');
const addMaturitiesChRoutes = require('./maturities-ch');
const addPriceHistoryRoutes = require('./price-history');
const addSearch = require('./position-search');
const addPositionDownloadsRoutes = require('./position-downloads');
const addEDelivery = require('./eDelivery');
const addTransactions = require('./transactions');
const addPayments = require('./payments');
const addPaymentsCheck = require('./payments-check');
const addPaymentsAvaloq = require('./payments-avaloq');
const validatePaymentBeneficiary = require('./payment');
const addResetCode = require('./reset-code');
const addEDeliveryCh = require('./edeliverych');
const addDocsign = require('./document-sign');
const addChat = require('./chat');
const addPushNotification = require('./pushnotification');
const addTrading = require('./trading');
const addUserProfile = require('./userprofile');
const addDocUpload = require('./doc-upload');

const addUserMgmt = require('./usermanagement');
const addRMAccess = require('./rm-access');
const addDataExports = require('./dataExports');
const addDashboard = require('./dashboard');
const manageContactDetails = require('./manage-contact-details');
const addAis = require('./account-information-service');
const cashAccounts = require('./cash-accounts');
const alerts = require('./alerts');
const addPis = require('./payment-initiation-service')
const addPaymentsMultisignatory = require('./multisignatory');
const addSepaIpPaymentStatus = require('./sepa-ip-service');

/**
 * @param {Object} config - config
 * @param {boolean} requestHandler - Request handler
 * @returns {Object} Muster app
 */
function createApp(config = {}) {
  assert('requestHandler' in config, 'requestHandler not provided');

  return flow(
    addInvestmentRoutes(config),
    addPortfolioRoutes(config),
    addAuthRoutes(config),
    addAlternativesRoutes(config),
    addBondsRoutes(config),
    addEquitiesRoutes(config),
    addMMInstruments(config),
    addVariousRoutes(config),
    addCashRoutes(config),
    addLoansRoutes(config),
    addOptionsRoutes(config),
    addFxForwardsRoutes(config),
    addMaturitiesRoutes(config),
    addEntitlementRoutes(config),
    addConsolidationeRoutes(config),
    addIncomeRoutes(config),
    addCurrencyRoutes(config),
    addReportsRoutes(config),
    addReportAdvicesRoutes(config),
    addPortfolioAssetsRoutes(config),
    addCioInsightsRoutes(config),
    addNotifications(config),
    addRmCallback(config),
    addDiscovery(config),
    marqueRoutes(config),
    addFeedback(config),
    addVascoAuthentication(config),
    addGlobalAuth(config),
    addTermsAndConditions(config),
    addGenericAssetsRoutes(config),
    addMaturitiesChRoutes(config),
    addPriceHistoryRoutes(config),
    addSearch(config),
    addPositionDownloadsRoutes(config),
    addEDelivery(config),
    addTransactions(config),
    addPayments(config),
    addPaymentsAvaloq(config),
    validatePaymentBeneficiary(config),
    addPaymentsCheck(config),
    addResetCode(config),
    addEDeliveryCh(config),
    addDocsign(config),
    addChat(config),
    addPushNotification(config),
    addTrading(config),
    addUserProfile(config),
    addDocUpload(config),
    addUserMgmt(config),
    addRMAccess(config),
    addDataExports(config),
    addDashboard(config),
    manageContactDetails(config),
    addAis(config),
    cashAccounts(config),
    alerts(config),
    addPis(config),
    addPaymentsMultisignatory(config),
    addSepaIpPaymentStatus(config)
  )(muster());
}

module.exports = createApp;
